import http from '@/libs/http'

export default {
  findAll(options) {
    const limit = 10
    const params = Object.assign({
      limit,
      offset: (options.page - 1) * limit,
      sort_by: 'updated_at',
      order: 'desc'
    }, options)
    return http.get('/cms/logs', { params }).then(result => result.data)
  },
  _clean(model) {
    const m = Object.assign({}, model)
    delete m.id
    return m
  }
}
